import React from "react";
import Hero from "../../components/medical/Hero";
import HighlightedContactSection from "../../components/HighlightedContactSection";

const PARAGRAPH_CLASS =
  "mt-3 text-sm leading-relaxed text-gray-700 md:text-base";

const SECTIONS = [
  {
    id: "section-sales-story",
    leftLabel: "REPEXO SALES",
    heading:
      "Headhunting für Vertriebspositionen genau in der Branche unserer Kunden – alle Vertriebsebenen!",
    paragraphs: [
      "Vertrieb ist unsere Passion … und das seit 1981. Eben diese Leidenschaft ist das Herz der REPEXO Sales. Jeder einzelne Berater im Haus verspürt dieses Brennen, hat dieses bestimmte Gen in sich – und das hört niemals auf.",
      "Seit 1981 beschäftigen wir uns mit dem Abwerben von Vertriebs- und Verkaufskandidaten aus verschiedenen Märkten für unsere Kunden. Das gezielte Suchen und Finden von Top-Vertriebskandidaten und Spezialisten – zum Beispiel hoch technisch veranlagte Vertriebsingenieure oder Vertriebler aus den Healthcare-Branchen –, aber auch sämtlich andere Branchen, die das Unternehmen unserer Kunden vertrieblich weiter nach vorne bringen.",
      "In der Branche unserer Mandanten – genau dort sitzen nämlich auch die guten Vertriebsleute unserer Kunden – und lassen sich in diskreter Direktansprache gerne von REPEXO Sales motivieren, einen Karriereschritt zu gehen. Wir verstehen haargenau die Sprache der Vertriebler und das zahlt sich aus!",
      "Korrekt durchgeführtes Headhunting, nämlich die richtige Ansprache von Kandidaten am Arbeitsplatz, bringt ausschließlich Kandidaten hervor, die keinen Wechselgedanken hatten, aber für unsere Kunden eine wichtige neue Person für den Vertrieb sind.",
      "Dumpingpreise gehen bei uns nicht – wir sind keine Discounter und wollen es auch nie werden. Zur unserer Historie gehören namhafte Kunden, die sich ebenfalls am Markt etabliert haben. Diese Kunden würden niemals ihre tollen Produkte verschleudern oder einfach nur über den Preis verkaufen. Wir tun es auch nicht. Qualität hat ihren Preis – und hält dafür nachhaltig.",
      "Devisen unseres Hauses waren und sind immer noch folgende Dinge: Wir arbeiten ausschließlich mit einem transparenten Festpreis in der Drittellösung. Wir betreiben Headhunting, das heißt, wir jagen die besten Köpfe für unsere Kunden.",
      "Social-Media-Suche ist nett, aber zu weichgespült für uns. Wir wollen zielführend arbeiten und langfristige Erfolge haben – für Sie! Vertrieb eben – durchaus geschmeidig – aber dann bitte auch unten rechts … Sie wissen schon … abschlussstark! Das ist das, was die Kunden von uns erwarten, und das ist auch unser Anspruch. Daran hat sich nichts geändert.",
      "Unsere Headhunter hatten schon immer spezielle Branchenkenntnisse und das geballte Fachwissen aus verschiedenen unterschiedlichen Branchen, um kompetent potenzielle Kandidaten zu finden.",
      "Bei der REPEXO Sales findet ein Kunde ausschließlich quirlige und vertriebsstarke Berater, die für Sie als Mandanten zu einem wertvollen Ansprechpartner werden und Sie durch das gesamte Projekt von A–Z begleiten. Denn nur so können wir für Sie erfolgreich sein. Wir sind keine Personalvermittler, die viele Märkte bedienen.",
      "Sondern wir sind Sales Headhunter – und das bis in die Haarspitzen! Durch unsere lange Marktpräsenz ist unsere Akzeptanz auch bei Kandidaten sehr hoch und wir können nachhaltige Erfolge nachweisen.",
      "All unsere Prozesse werden ausschließlich inhouse abgebildet. Wir arbeiten nicht mit Fremdkräften oder Research-Unternehmen. Nur so ist gewährleistet, dass wir von Anfang an das Ohr am Nabel des Geschehens haben und in keiner Projektphase wichtige Informationen verloren gehen.",
      "Wir unterscheiden uns erheblich von einem Personalvermittler. Wir sind REPEXO Sales! Vertrieb braucht Spezialisten – und um Vertriebsleute zu finden, braucht es Spezialisten.",
      "Jeder Tag in Ihrem Unternehmen, an dem der wirklich passende Vertriebsmitarbeiter fehlt, ist für Sie ein verlorener Tag.",
      "Rufen Sie uns an, wir helfen Ihnen weiter und lamentieren nicht lange herum – sondern packen an, wo wir gebraucht werden!",
    ],
  },
];

export default function SalesStoryPage() {
  return (
    <>
      <Hero
        title="Referenzen"
        subheading="Headhunting im Vertrieb seit 1981."
      />
      <section className="bg-white pt-0 pb-16 md:pb-24">
        {SECTIONS.map((section) => (
          <div
            key={section.id}
            id={section.id}
            className="border-b border-gray-100 py-12 md:py-16 first:pt-8"
          >
            <div className="container-app mx-auto flex flex-col gap-8 px-4 md:flex-row md:gap-12 lg:gap-16">
              {section.leftLabel && (
                <div className="flex-shrink-0 md:w-36 lg:w-40">
                  <span className="detail-side-label text-xs font-semibold uppercase tracking-[0.2em] text-gray-700">
                    {section.leftLabel}
                  </span>
                </div>
              )}
              <div className="min-w-0 flex-1 max-w-4xl">
                <h2 className="text-2xl font-semibold leading-snug text-gray-900 md:text-3xl">
                  {section.heading}
                </h2>
                {section.paragraphs?.map((p, j) => (
                  <p key={j} className={PARAGRAPH_CLASS}>
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </div>
        ))}
        <HighlightedContactSection
          heading="Mehr über REPEXO Sales erfahren?"
          description="Wir erläutern Ihnen gerne, wie wir Vertriebspositionen für Ihr Unternehmen besetzen."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-sales-story-contact"
        />
      </section>
    </>
  );
}

